
import { Vue, Component } from "vue-property-decorator"

@Component
export default class Header3 extends Vue {}
